import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { useMsal } from '@azure/msal-react';
import UserModel from '../models/UserModel';
import { AuthenticationContextType } from '../types/AuthenticationContextType';

const AuthenticationContext = createContext<AuthenticationContextType | undefined>(undefined);

export const AuthenticationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { accounts, inProgress } = useMsal();
    const isLoading = inProgress === 'startup' || inProgress === 'handleRedirect';
    const userInfo = useMemo(
        () => (isLoading || accounts.length === 0 ? null : new UserModel(accounts[0])),
        [accounts, isLoading]
    );

    const value: AuthenticationContextType = {
        userInfo,
        isLoading,
        isAuthenticated: !!userInfo
    };

    return (
        <AuthenticationContext.Provider value={value}>
            {children}
        </AuthenticationContext.Provider>
    );
};

export const useAuthentication = (): AuthenticationContextType => {
    const context = useContext(AuthenticationContext);
    if (context === undefined) {
        throw new Error('useAuthentication must be used within an AuthenticationProvider');
    }
    return context;
};
